import { render, staticRenderFns } from "./StudentListTable.vue?vue&type=template&id=5427d1b9&scoped=true&lang=pug"
import script from "./StudentListTable.vue?vue&type=script&lang=ts"
export * from "./StudentListTable.vue?vue&type=script&lang=ts"
import style0 from "./StudentListTable.vue?vue&type=style&index=0&id=5427d1b9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5427d1b9",
  null
  
)

export default component.exports